// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"3651":"131c4705","8035":"f31aec94"}[chunkId] || chunkId) + "-" + {"1832":"46f2622cde129dad","3651":"41b0e4dadecf15eb","6009":"26067fc027212f4c","6330":"18774be5cc573124","8035":"3c0c0b90085fa632"}[chunkId] + ".js";
};